import { useUser } from 'containers/App/context/useUser';

export function useUserRoles() {
  const user = useUser();
  const hasRoleDirector = !!user?.roles?.includes('director');
  const hasRoleTeacher = !!user?.roles?.includes('teacher');

  return {
    hasRoleDirector,
    hasRoleTeacher,
  };
}
